export default [
    {
        method: 'getCaptcha',
        type: 'GET',
        path: '/captcha/sget',
        mode: 'csMng',
        params: [],
        options: {cache: false},
        switch: true
    },
    {
        method: 'login',
        type: 'POST',
        path: '/login',
        mode: 'csMng',
        params: ['account_id', 'account_pwd', 'token', 'captcha_code'],
        options: {withCredentials: true, cache: false},
        switch: true
    },
    {
        method: 'loginCheck',
        type: 'GET',
        path: '/login_check',
        mode: 'csMng',
        params: [],
        options: {withCredentials: true, cache: false},
        switch: true
    },
    {
        method: 'userInfo',
        type: 'GET',
        path: '/account/detail',
        mode: 'csMng',
        params: ['account_id', 'region'],
        options: {withCredentials: true, cache: false},
        switch: true
    },
    {
        method: 'logout',
        type: 'GET',
        path: '/login_out',
        mode: 'csMng',
        params: [],
        options: {withCredentials: true, cache: false},
        switch: true
    },
    {
        method: 'startExportOrder',
        type: 'POST',
        path: '/komoe/mng/work_order/excel_download_derive',
        mode: 'csMng',
        options: {dataFormat: 'json', withCredentials: true, cache: false},
        switch: true
    },
    {
        method: 'getExportState',
        type: 'GET',
        path: '/komoe/mng/work_order/excel_sign_check',
        mode: 'csMng',
        options: {dataFormat: 'json', withCredentials: true, cache: false},
        switch: true
    },
    {
        method: 'orderList',
        type: 'POST',
        path: '/komoe/mng/work_order/page',
        mode: 'csMng',
        params: ['character_id', 'game_base_id', 'question_type', 'work_order_status', 'question_keyword', 'content_keyword', 'answer_keyword', 'start_time', 'end_time', 'page_num', 'page_size', 'uid', 'operator_name', 'order_key', 'order_type', 'ct'],
        options: {dataFormat: 'json', withCredentials: true, cache: false},
        switch: true
    },
    {
        method: 'commonQuestionTypeList',
        type: 'GET',
        path: '/komoe/api/common/question_type/list',
        mode: 'cs',
        params: ['usage'],
        options: {cache: false},
        switch: true
    },
    {
        method: 'commonGameList',
        type: 'GET',
        path: '/komoe/api/common/game/list',
        mode: 'cs',
        params: [],
        options: {cache: false},
        switch: true
    },
    {
        method: 'orderDetail',
        type: 'GET',
        path: '/komoe/mng/work_order/detail',
        mode: 'csMng',
        params: ['work_order_id'],
        options: {withCredentials: true, cache: false},
        switch: true
    },
    {
        method: 'updateOrder',
        type: 'POST',
        path: '/komoe/mng/work_order/modify',
        mode: 'csMng',
        params: ['work_order_id', 'work_order_status', 'game_base_id', 'question_type', 'ct'],
        options: {dataFormat: 'json', withCredentials: true, cache: false},
        switch: true
    },
    {
        method: 'replyOrder',
        type: 'POST',
        path: '/komoe/mng/work_order/reply',
        mode: 'csMng',
        params: ['work_order_id', 'reply_content', 'reply_status', 'ct'],
        options: {dataFormat: 'json', withCredentials: true, cache: false},
        switch: true
    },
    {
        method: 'batchReply',
        type: 'POST',
        path: '/komoe/mng/work_order/batch_reply',
        mode: 'csMng',
        params: ['work_order_list', 'reply_content', 'reply_status', 'ct'],
        options: {dataFormat: 'json', withCredentials: true, cache: false},
        switch: true
    },
    {
        method: 'userRecord',
        type: 'POST',
        path: '/mng/work_order/user_submit_record',
        mode: 'csMng',
        params: ['game_base_id', 'uid', 'page_num', 'page_size'],
        options: {dataFormat: 'json', withCredentials: true, cache: false},
        switch: true
    },
    {
        method: 'accountList',
        type: 'GET',
        path: '/account/list',
        mode: 'csMng',
        params: ['s_account_id', 'page_num', 'page_size'],
        options: {withCredentials: true, cache: false},
        switch: true
    },
    {
        method: 'accountDetail',
        type: 'GET',
        path: '/account/detail',
        mode: 'csMng',
        params: ['account_id', 'ct'],
        options: {withCredentials: true, cache: false},
        switch: true
    },
    {
        method: 'addAccount',
        type: 'POST',
        path: '/account/add',
        mode: 'csMng',
        params: ['account_id', 'account_name', 'account_pwd', 'privilege_ids', 'ct'],
        options: {withCredentials: true, cache: false},
        switch: true
    },
    {
        method: 'updateAccount',
        type: 'POST',
        path: '/account/save',
        mode: 'csMng',
        params: ['account_id', 'account_name', 'account_pwd', 'privilege_ids', 'ct'],
        options: {withCredentials: true, cache: false},
        switch: true
    },
    {
        method: 'deleteAccount',
        type: 'GET',
        path: '/account/del',
        mode: 'csMng',
        params: ['account_id'],
        options: {withCredentials: true, cache: false},
        switch: true
    },
    {
        method: 'blockAccount',
        type: 'GET',
        path: '/account/limit',
        mode: 'csMng',
        params: ['account_id'],
        options: {withCredentials: true, cache: false},
        switch: true
    },
    {
        method: 'unsealAccount',
        type: 'GET',
        path: '/account/unseal',
        mode: 'csMng',
        params: ['account_id'],
        options: {withCredentials: true, cache: false},
        switch: true
    },
    {
        method: 'faqList',
        type: 'GET',
        path: '/komoe/mng/question/page',
        mode: 'csMng',
        params: ['game_base_id', 'question_type', 'question_keyword', 'page_num', 'page_size'],
        options: {withCredentials: true, cache: false},
        switch: true
    },
    {
        method: 'faqUpdate',
        type: 'POST',
        path: '/komoe/mng/question/create_update',
        mode: 'csMng',
        params: ['game_base_id', 'question_id', 'question_type', 'question_title', 'question_content', 'online_type', 'online_time'],
        options: {withCredentials: true, cache: false},
        switch: true
    },
    {
        method: 'faqDetail',
        type: 'GET',
        path: '/komoe/mng/question/detail',
        mode: 'csMng',
        params: ['question_id'],
        options: {withCredentials: true, cache: false},
        switch: true
    },
    {
        method: 'faqOnline',
        type: 'POST',
        path: '/komoe/mng/question/online/switch',
        mode: 'csMng',
        params: ['question_id', 'is_online'],
        options: {withCredentials: true, cache: false},
        switch: true
    },
    {
        method: 'faqDelete',
        type: 'POST',
        path: '/komoe/mng/question/delete',
        mode: 'csMng',
        params: ['question_id'],
        options: {withCredentials: true, cache: false},
        switch: true
    },
    {
        method: 'sdkGameList',
        type: 'POST',
        path: '/komoe/mng/game/search',
        mode: 'csMng',
        options: {withCredentials: true, cache: false},
        switch: true
    },
    {
        method: 'gameList',
        type: 'GET',
        path: '/komoe/mng/game/page',
        mode: 'csMng',
        options: {withCredentials: true, cache: false},
        switch: true
    },
    {
        method: 'createOrUpdateGame',
        type: 'POST',
        path: '/komoe/mng/game/create_update',
        mode: 'csMng',
        options: {withCredentials: true, cache: false},
        switch: true
    },
    {
        method: 'gameDetail',
        type: 'GET',
        path: '/komoe/mng/game/detail',
        mode: 'csMng',
        params: ['game_base_id'],
        options: {withCredentials: true, cache: false},
        switch: true
    },
    {
        method: 'gamePublish',
        type: 'POST',
        path: '/komoe/mng/game/online/switch',
        mode: 'csMng',
        options: {withCredentials: true, cache: false},
        switch: true
    },
    {
        method: 'gameDelete',
        type: 'POST',
        path: '/komoe/mng/game/delete',
        mode: 'csMng',
        params: ['game_base_id'],
        options: {withCredentials: true, cache: false},
        switch: true
    },
    {
        method: 'orderRecall',
        type: 'POST',
        path: '/komoe/mng/work_order/recall',
        mode: 'csMng',
        params: ['work_order_id'],
        options: {dataFormat: 'json', withCredentials: true, cache: false},
        switch: true
    },
    {
        method: 'unlockOrder',
        type: 'POST',
        path: '/komoe/mng/work_order/back_editing_finished',
        mode: 'csMng',
        params: ['work_order_id'],
        options: {dataFormat: 'json', withCredentials: true, cache: false},
        switch: true
    },
    {
        method: 'lockOrder',
        type: 'POST',
        path: '/komoe/mng/work_order/editing_lock',
        mode: 'csMng',
        params: ['work_order_id'],
        options: {dataFormat: 'json', withCredentials: true, cache: false},
        switch: true
    },
    {
        method: 'faqRecommend',
        type: 'GET',
        path: '/komoe/mng/question/title_match',
        mode: 'csMng',
        params: ['keywords', 'game_base_id', 'page_size', 'page_num'],
        options: {dataFormat: 'json', withCredentials: true, cache: false},
        switch: true
    }
]